import { DbCreateInputOmit, DbUpdate } from "../../helpers";
import { OmitStrict } from "../../utils";
import { z } from "zod";

export const ElementViewBaseColumnType = z.enum(["Name", "Description", "Value", "UpdatedAt"]);

export const ElementViewColumnType = z.union([
  z.literal("BaseProperty"),
  z.literal("PropertyDefinition"),
  z.literal("Theme"),
]);

export const ElementViewColumnSharedAttributes = z.object({
  id: z.string(),
  persistentId: z.string(),
  elementDataViewId: z.string(),
  sortPosition: z.number(),
  width: z.number(),
});

export const ElementViewBasePropertyColumn = ElementViewColumnSharedAttributes.extend({
  type: z.literal("BaseProperty"),
  basePropertyType: ElementViewBaseColumnType,
});

export const ElementViewPropertyDefinitionColumn = ElementViewColumnSharedAttributes.extend({
  type: z.literal("PropertyDefinition"),
  propertyDefinitionId: z.string(),
});

export const ElementViewThemeColumn = ElementViewColumnSharedAttributes.extend({
  type: z.literal("Theme"),
  themeId: z.string(),
});

export const ElementViewColumn = z.discriminatedUnion("type", [
  ElementViewBasePropertyColumn,
  ElementViewPropertyDefinitionColumn,
  ElementViewThemeColumn,
]);

export type ElementViewBaseColumnType = z.infer<typeof ElementViewBaseColumnType>;
export type ElementViewBasePropertyColumn = z.infer<typeof ElementViewBasePropertyColumn>;
export type ElementViewPropertyDefinitionColumn = z.infer<typeof ElementViewPropertyDefinitionColumn>;
export type ElementViewThemeColumn = z.infer<typeof ElementViewThemeColumn>;
export type ElementViewColumn = z.infer<typeof ElementViewColumn>;
export type ElementViewColumnSharedAttributes = z.infer<typeof ElementViewColumnSharedAttributes>;
export type ElementViewColumnType = z.infer<typeof ElementViewColumn>["type"];

export type CreateElementViewColumn =
  | DbCreateInputOmit<ElementViewBasePropertyColumn>
  | DbCreateInputOmit<ElementViewPropertyDefinitionColumn>
  | DbCreateInputOmit<ElementViewThemeColumn>;

export type UpdateElementViewColumn =
  | OmitStrict<DbUpdate<ElementViewBasePropertyColumn>, "elementDataViewId">
  | OmitStrict<DbUpdate<ElementViewPropertyDefinitionColumn>, "elementDataViewId">
  | OmitStrict<DbUpdate<ElementViewThemeColumn>, "elementDataViewId">;
